<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import store from './store'
	// import {
	// 	forEach
	// } from 'core-js/es7/array';
	//判斷ip地址
	let resData = '';
	//不屏蔽的地址
	let ipList = ['/notice', '/course', '/cannotAccess', 'localhost', '/invitation', '/newyear_activity', '/sign-in'];
	export default {
		name: 'app',
		components: {

		},
		watch: {
			$route(e) {
				//  window.location.href
				// if ( !resData && resData.areaCode != 1 ) {
				// 	let ipUrl = true;
				// 	//先看看是不是 公告或教程
				// 	for ( let i in ipList ) {
				// 		if ( e.path.indexOf( ipList[ i ] ) >= 0 ) {
				// 			ipUrl = false;
				// 			break
				// 		}
				// 	}
				// 	//判断是否
				// 	if ( e.query.download ) {
				// 		ipUrl = false;
				// 	}
				// 	console.log( 111, ipUrl )

				// 	if ( ipUrl ) {
				// 		this.$MyAxios.get( `/api/accounts/ipAddr`, res => {
				// 			resData = res.data
				// 			// console.log( 2222, resData )
				// 			// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
				// 			if ( resData.areaCode == 1 ) {
				// 				this.$router.push( {
				// 					name: 'cannotAccess'
				// 				} )
				// 			}
				// 		}, err => {
				// 			resData = err.data
				// 			// console.log( 444, resData )
				// 			// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
				// 			if ( resData.areaCode == 1 ) {
				// 				this.$router.push( {
				// 					name: 'cannotAccess'
				// 				} )
				// 			}
				// 		} )
				// 	}
				// }
			}
		},
		mounted() {
			try {
				const script = document.createElement('script')
				script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
				script.language = 'JavaScript'
				document.body.appendChild(script)
			} catch (e) {
				//TODO handle the exception
			}
			this.getDDNS()

		},
		methods: {
			//获取动态域名
			getDDNS() {
				this.$MyAxios.get('/api/v2/domainNames', {}, res => {
					let data = res.data;
					//赋值域名
					store.dispatch('app/setDDNS', {
						'DDNS': data,
						'httpImg': data['oss-image'][0] 
                        //'https://xp-oss-bucket-image-prod.oss-cn-hongkong.aliyuncs.com/invitation-xp' // + '/invitation-xp', //图片请求域名   //
					});
					// console.log(222, store.state.app)
				}, error => {
					console.log(111, error)
				})
			}
		}
	}
</script>

<style lang="less">
	@import "./style/common";

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100%;
		position: relative;
	}
</style>